module.exports = __webpack_public_path__ + "img/logo.8d1b6c9f.png";